export default "__VITE_ASSET__BeRldZV9__"